import i18n from '@/i18n'
import _ from 'lodash'
import Generator from './Generator'
import RenderData from './RenderData'
import router from '@/router/routes'
import navigation from './modules/navigation'
import { MICRO_SITE_TYPE } from '../../../constant/common'

const IDGenerator = new Generator()

class PageData {
  constructor (name, path, renderData, id = -1, isIndex = false, metaInfo = null, status = null) {
    this.name = name
    this.path = path
    this.renderData = renderData
    this.metaInfo = metaInfo
    this.isIndex = isIndex
    this.status = status
    if (id <= 0) {
      id = IDGenerator.nextValue()
    }
    this.id = id
    this.languageCode = PageData.getLanguageCode()
  }

  static getLanguageCode () {
    return window.location.pathname.indexOf('en/onboarding/index') > -1 ? 'en' : 'zh-cn'
  }

  toObject () {
    const obj = {}
    obj.id = this.id
    obj.name = this.name
    obj.path = this.path
    obj.isIndex = this.isIndex
    obj.renderData = this.renderData.toObject()
    obj.metaInfo = _.cloneDeep(this.metaInfo)
    obj.status = _.cloneDeep(this.status) // to-do recheck maybe need not to object
    return obj
  }

  static parseObject ({ id, name, path, renderData, isIndex, metaInfo, status }) {
    if (id >= IDGenerator.current) {
      IDGenerator.reset(id)
    }
    const pageData = new this(name, path, RenderData.parseObject(renderData), id, isIndex, metaInfo, status)
    return pageData
  }

  static createDefaultPages (language = 'en') {
    const pages = []
    const renderData = RenderData.createDefaultRootRenderData()
    const metaInfo = {
      title: '首页'
    }
    const status = {
      edit: true,
      delete: false,
      show: true
    }
    const indexPage = new PageData('首页', '/index', renderData, -1, true, metaInfo, status)
    pages.push(indexPage)
    const siteType = router.currentRoute.params.type
    if (siteType === MICRO_SITE_TYPE.onboarding) {
      const pageTitle = i18n.t('microSite.editor.page.onboardingPageTitle', language)
      const questionnairePage = new PageData(
        pageTitle,
        '/v/onboarding/questionnaire',
        RenderData.createDefaultRootRenderData(),
        -1,
        false,
        {
          title: pageTitle
        },
        {
          edit: false,
          delete: false,
          show: true,
          hiddenConfigPageBtn: true,
          hiddenSelectPageBtn: true,
          onboarding: true
        })
      pages.push(questionnairePage)
      const firstPageNav = _.find(renderData.children, { tag: navigation.name })
      firstPageNav.data.props.menus.push({
        label: pageTitle,
        path: '/v/onboarding/questionnaire',
        isInner: true,
        openInNewWindow: false,
        isOnboardingPage: true
      })
    }
    if (siteType === MICRO_SITE_TYPE.satisfaction_survey) {
      const pageTitle = i18n.t('microSite.editor.page.satisfactionSurveyPageTitle', language)
      const questionnairePage = new PageData(
        pageTitle,
        '/v/satisfaction-survey/questionnaire',
        RenderData.createDefaultRootRenderData(),
        -1,
        false,
        {
          title: pageTitle
        },
        {
          edit: false,
          delete: false,
          show: true,
          hiddenConfigPageBtn: true,
          hiddenSelectPageBtn: true,
          onboarding: false,
          satisfactionSurvey: true
        })
      pages.push(questionnairePage)
      const firstPageNav = _.find(renderData.children, { tag: navigation.name })
      firstPageNav.data.props.menus.push({
        label: pageTitle,
        path: '/v/satisfaction-survey/questionnaire',
        isInner: true,
        openInNewWindow: false,
        isOnboardingPage: false,
        isSatisfactionSurveyPage: true
      })
    }
    if (_.includes([MICRO_SITE_TYPE.post_applicant, MICRO_SITE_TYPE.job_application], siteType)) {
      const pageTitle = i18n.t('microSite.editor.page.postApplicantPageTitle', language)
      const questionnairePage = new PageData(
        pageTitle,
        '/v/candidate-portal/questionnaire',
        RenderData.createDefaultRootRenderData(),
        -1,
        false,
        {
          title: pageTitle
        },
        {
          edit: true,
          delete: false,
          show: true,
          hiddenSelectPageBtn: true,
          onboarding: false,
          satisfactionSurvey: true
        })
      pages.push(questionnairePage)
      const firstPageNav = _.find(renderData.children, { tag: navigation.name })
      firstPageNav.data.props.menus.push({
        label: pageTitle,
        path: '/v/candidate-portal/questionnaire',
        isInner: true,
        openInNewWindow: false,
        isOnboardingPage: false,
        isSatisfactionSurveyPage: true
      })
    }
    return pages
  }
}

export default PageData

export function resetIDGenerator (start, step) {
  IDGenerator.reset(start, step)
}
